import { tv } from 'tailwind-variants';

const navSplashVariants = tv(
  {
    slots: {
      base: 'relative grid max-h-[190px]',
      image:
        'col-span-full row-span-full h-full w-full aspect-[4/5] max-h-[190px] object-cover',
      content:
        'text-white col-span-full row-span-full flex flex-col items-start text-black',
      heading: ['text-sm', 'hover:underline'],
      subheading: 'font-normal max-lg:text-sm tracking-wide text-sm font-serif',
    },
    variants: {
      backdrop: {
        true: {
          base: 'bg-beige',
        },
      },
    },
  },
  {
    responsiveVariants: true,
  },
);

export default navSplashVariants;
